var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('files',{attrs:{"files":_vm.files,"title":_vm.title,"is_uploading":_vm.is_uploading,"disabled":_vm.disabled,"show_description":true},on:{"add":_vm.addFile}})}
var staticRenderFns = []

export { render, staticRenderFns }